import { createContext, useContext } from "react";
import useSuperDashboard from "../hooks/useSuperDashboard";

const SuperDashboardContext = createContext(null);

export const SuperDashboardContextProvider = ({ children }) => {
    const dashboard = useSuperDashboard();
    return (
        <SuperDashboardContext.Provider value={dashboard}>
            {children}
        </SuperDashboardContext.Provider>
    );
};

export const useSuperDashboardContext = () => useContext(SuperDashboardContext);
